import { Years, TeamResults, SiteData, PersonData } from '../clients/data-service';
import  { TeamGrid } from "./TeamGrid";
import React from "react";
import {
    Box,
    Button,
    HStack, 
    IconButton, 
    Select,
    Tooltip,
    VStack} from '@chakra-ui/react';
import { SmallCloseIcon } from '@chakra-ui/icons'
import { OrderByString } from '../utilities/DataTools';
import { RouteComponentProps, withRouter } from './withRouter';
import { BuildFilter } from '../utilities/TeamFiltering';
import { PersonSurnameFirst } from '../utilities/PeopleUtilities';

export type ExploreProps = {
    siteData: SiteData;
};

export type ExploreState = {
};

class Explore1 extends React.Component<ExploreProps & RouteComponentProps, ExploreState> {
    constructor(props) {
        super(props);
        this.state = {
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        if (value === "") {
            value = undefined;
        }
        const formField = target.name;
        const location = window.location;
        const params = new URLSearchParams(location.search);
        if (value) {
            params.set(formField, value);
        } else {
            params.delete(formField);
        }
        this.props.navigate(location.pathname + '?' + params.toString());
    }

    clearFilters() {
        const location = window.location;
        this.props.navigate(location.pathname);
        this.forceUpdate();
    }


    render() {

        const filter = BuildFilter();
        return (
            <Box w="fill" marginLeft={{ base: 2, md: 20 }} marginRight={{ base: 2, md: 20 }} mb={20}>
                <HStack spacing={3} mb={10} display={{ base: 'none', md: 'flex' }}>
                    <Select name="year" placeholder="All Years" value={filter.year ?? ""} onChange={this.handleInputChange}>
                        {Years().map(year => <option key={year} value={year}>{year}</option>)}
                    </Select>
                    <Select name="result" placeholder="All Results" value={filter.result ?? ""} onChange={this.handleInputChange}>
                        {TeamResults().filter(grade => grade.Key !== "Other").map(grade => <option key={grade.Key} value={grade.Key}>{grade.Selection}</option>)}
                    </Select>
                    <Select name="person" placeholder="All People" value={filter.person ?? ""} onChange={this.handleInputChange}>
                        {OrderByString(this.props.siteData.People, p => PersonSurnameFirst(p)).map(person => <option key={person.id} value={person.id}>{PersonSurnameFirst(person)}</option>)}
                    </Select>
                    <Tooltip label='Clear Filters' fontSize='md'>
                        <IconButton aria-label='Clear Filters' icon={<SmallCloseIcon />} onClick={this.clearFilters} />
                    </Tooltip>
                </HStack>
                <VStack spacing={2} mb={4} display={{ md: 'none' }}>
                    <Select name="year" placeholder="All Years" value={filter.year ?? ""} onChange={this.handleInputChange}>
                        {Years().map(year => <option key={year} value={year}>{year}</option>)}
                    </Select>
                    <Select name="result" placeholder="All Results" value={filter.result ?? ""} onChange={this.handleInputChange}>
                        {TeamResults().filter(grade => grade.Key !== "Other").map(grade => <option key={grade.Key} value={grade.Key}>{grade.Selection}</option>)}
                    </Select>
                    <Select name="person" placeholder="All People" value={filter.person ?? ""} onChange={this.handleInputChange}>
                        {OrderByString(this.props.siteData.People, p => PersonSurnameFirst(p)).map(person => <option key={person.id} value={person.id}>{PersonSurnameFirst(person)}</option>)}
                    </Select>
                    <Button aria-label='Clear Filters' size={'sm'} onClick={this.clearFilters}>
                        Clear Filters
                    </Button>
                </VStack>
                <TeamGrid filter={filter} />
            </Box>
        );
    }
}

export const Explore = withRouter<ExploreProps>(Explore1);
